import React, { useEffect, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Alert, Button } from '@mui/material'

import { getSessionById } from '../../../service/sessionService'
import { conditionOf, conditionTagOf, experimentConfigOf } from './experimentConfig'

// On a condition session's own page (staff only): which experiment it belongs to, that
// changes here affect this condition alone, and the way back to the experiment's page.
const ConditionBanner = ({ session }) => {
  const tag = conditionTagOf(session)
  // undefined while loading; null when the experiment is gone (or could not be read)
  const [experimentRow, setExperimentRow] = useState(undefined)

  useEffect(() => {
    if (!tag) return
    let cancelled = false
    setExperimentRow(undefined)
    getSessionById(tag.experimentId)
      .then((row) => {
        if (!cancelled) setExperimentRow(row && !row.is_deleted ? row : null)
      })
      .catch(() => {
        // Not knowing is not the same as gone: say nothing rather than something wrong.
        if (!cancelled) setExperimentRow(undefined)
      })
    return () => {
      cancelled = true
    }
  }, [tag?.experimentId]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!tag || experimentRow === undefined) return null
  const config = experimentConfigOf(experimentRow)
  const condition = conditionOf(session, experimentRow)

  return (
    <Alert
      severity="info"
      sx={{ borderRadius: 0, width: '100%', boxSizing: 'border-box' }}
      action={
        config && (
          <Button component={RouterLink} to={`/session/${tag.experimentId}`} color="inherit" size="small">
            Open experiment
          </Button>
        )
      }>
      {config ? (
        <>
          Part of experiment <strong>{config.name}</strong>
          {condition && (
            <>
              {' '}
              · Condition <strong>{condition.name}</strong>
            </>
          )}
          . Changes here apply to this condition only.
        </>
      ) : (
        'This session was published as a condition of an experiment that is no longer in your session list. It works as an ordinary session.'
      )}
    </Alert>
  )
}

export default ConditionBanner
